import { mainColor, UNIT } from '../../constants/theme';

export const styles = () => ({
  progress: {
    textAlign: 'center',
    color: mainColor.secondaryColor
  },
  button: {
    backgroundColor: mainColor.colorWhite
  },
  root: {
    width: '100%',
    overflowX: 'auto'
  },
  table: {
    minWidth: 700
  },
  icon: {
    fontSize: '24px',
    color: 'black'
  },
  heading: {
    fontSize: UNIT * 0.9375,
    fontWeight: 'bolder',
    minWidth: UNIT * 12,
    color: mainColor.colorBlackLight
  },
  lastHeading: {
    fontSize: UNIT * 0.9375,
    fontWeight: 'bolder',
    color: mainColor.colorBlackLight
  },
  row: {
    fontSize: UNIT * 0.9375,
    flexBasis: '19%',
    flexShrink: 0,
    color: 'black !important'
  },
  lastRow: {
    padding: UNIT * 0.5625
  },
  svg: {
    padding: UNIT * 0.625
  }
});
